import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OnboardingService } from '@/home/onboarding/onboarding.service';
import { UserService } from '@/core/services/open-api/user.service';
import { RoleService } from '@/core/services/role.service';
import { CurrentUser } from '@/core/models/user';
import { combineLatest, Subscription } from 'rxjs';
import { AngularTranslations } from '@/core/types/angular-primeng-api';
import { Router } from '@angular/router';

@Component({
    selector: 'app-onboarding-progress-bar',
    standalone: false,
    template: `
        <div *ngIf="shouldShowOnboarding()" class="p-4 onboarding-progress-bar">
            <div class="font-bold text-xl text-white/80 mt-2">{{ 'onboarding_menu_title' | translate }}</div>
            <div class="text-white/50 mt-2 text-sm">{{ stepsDone }} {{ 'onboarding_step' | translate }}</div>
            <div class="mt-4">
                <p-progressBar
                    styleClass="customProgress"
                    [value]="stepsProgress"
                    [style]="{ height: '6px' }"
                    [showValue]="false"
                >
                </p-progressBar>
            </div>
            <div class="mt-6" *ngIf="!router.url.includes('onboarding')">
                <p-button
                    pRipple
                    type="button"
                    severity="success"
                    [style]="{ width: '100%' }"
                    label="{{ 'onboarding_menu_item' | translate }}"
                    [routerLink]="['/onboarding']"
                ></p-button>
            </div>
        </div>
    `,
})
export class OnboardingProgressBarComponent {
    subscriptions = new Subscription();
    currentUser?: CurrentUser;
    steps: boolean[] = [];
    stepsDone = '';
    stepsProgress = 0;
    standard_of: string = 'of';

    constructor(
        private readonly onboardingService: OnboardingService,
        private readonly translate: TranslateService,
        public readonly userService: UserService,
        private readonly roleService: RoleService,
        public readonly router: Router,
    ) {}

    ngOnInit(): void {
        this.subscriptions.add(
            combineLatest([
                this.userService.currentUser$,
                this.onboardingService.steps$,
                this.translate.get(['standard_of']),
            ]).subscribe(([user, steps, translations]: [CurrentUser, boolean[] | undefined, AngularTranslations]) => {
                this.currentUser = user;
                const allStepsAreDone = steps?.every((value) => !!value);
                this.steps = allStepsAreDone === true ? [] : steps || [];
                const doneSteps = this.steps.filter((value) => !!value).length;
                this.stepsDone = `${doneSteps} ${this.standard_of} ${this.steps.length}`;
                this.stepsProgress = (100 * doneSteps) / this.steps.length;
                this.standard_of = translations['standard_of'];
            }),
        );
        this.userService.loadCurrentUser().subscribe();
    }

    public shouldShowOnboarding(): boolean {
        const isAdmin = this.currentUser?.hasMultiPermission(this.roleService.adminRoles) ?? false;
        const isMenuFilled = true; // this.model.length > 0
        return isMenuFilled && isAdmin && this.steps.length > 0;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
